export default "__VITE_ASSET__DW8peHTI__"